const stats = [
  { value: '70%', label: '回單生產率' },
  { value: '250+', label: '合作品牌數' },
  { value: '1600+', label: '配方數據庫' },
  { value: '7', label: '劑型種類' },
];

export default function StatsSection() {
  return (
    <section className="py-16 bg-[#2d5a2d]">
      <div className="max-w-screen-xl mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
          {stats.map((stat) => (
            <div key={stat.label} className="text-center">
              <p className="text-white font-bold text-[2rem] md:text-[2.75rem] xl:text-[3.25rem] leading-none mb-2">{stat.value}</p>
              <p className="text-green-200 text-[1rem] leading-[1.75]">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
